import { useGetActiveDealsQuery } from "store/apis/personalDailyDealsAPI"

export const usePersonalDailyDeals = () => {
  const { data: personalDeal, isLoading } = useGetActiveDealsQuery()

  return {
    personalDeal,
    isLoading
  }
}
